<style scoped>
    @import url("../../styles/loraPub/pontosLoraPub.scss");
</style>

<template>
    <div class="box_pontosLoraPub" id="pontosLoraPubid"></div>
</template>

<script>
import L from "leaflet"; // npm install --save leaflet
//import axios from 'axios'

export default {

    props:['listaCoords'],

    data() {
        return {
            //
        }
    },

    methods:{
        //
        mapa () {
            // remontar o mapa? /xgetxinfolorax 
        }
    },

    mounted() {
        // coordenada upinc covilha 40.2789636, -7.5040484,275
        // setView([latitude, longitude], zoom)
        //var map = L.map('mapaid').setView([40.2789636, -7.5040484,275], 9.5);
        var map = L.map('pontosLoraPubid').setView([40.1622213, -7.4253607], 11.5); // [40.1222213, -7.4153607]

        //console.log('signal map start | PontosMap')

        // -- EXIBIÇÃO PONTOS CAPTADOS INDIVIDUALMENTE NO TERRENO.
        //console.log('this.listaCoords: ',this.listaCoords)
        //var count = 0
        //var flagStopTest = true
        var c=0
        //console.log('[ponto lora pub] this.listaCoords: ',this.listaCoords)
        //console.log('[ponto lora pub] this.listaCoords.length: ',this.listaCoords.length)
        while (c < this.listaCoords.length) { // lista rcv via props.

            if (this.listaCoords[c].length == 3) {

                L.circle([this.listaCoords[c][0],this.listaCoords[c][1]], {
                    color: 'red',
                    fillColor: '#f03',
                    fillOpacity: 0.2,
                    radius: 5 // metros
                }).addTo(map);
            }

            if (this.listaCoords[c].length >= 4) {

                /*if (flagStopTest) {

                    L.circle([40.079852562499994, -7.4279590281250005], {
                        color: 'red',
                        fillColor: '#f03',
                        fillOpacity: 0.3,
                        radius: 5327.17411400244 // metros
                    }).addTo(map);
                    
                    L.circle([40.176269562499996, -7.345292199999999], {
                        color: 'red',
                        fillColor: '#f03',
                        fillOpacity: 0.3,
                        radius: 9850.305231764929 // metros
                    }).addTo(map);

                    flagStopTest = false
                }*/

                //console.log('this.listaCoords: ',this.listaCoords[c])

                /*if (this.listaCoords[c][5] == 'Gateway Fundão Salgueiro') {

                    //console.log('Gateway Fundão Salgueiro')
                    //console.log('this.listaCoords: ',this.listaCoords[c])
                    //count++
                    
                    L.circle([this.listaCoords[c][0],this.listaCoords[c][1]], {
                        color: 'blue',
                        fillColor: '#f03',
                        fillOpacity: 0.2,
                        radius: 5 // metros
                    }).addTo(map)
                    .bindPopup(this.listaCoords[c][3]);
                }*/

                L.circle([this.listaCoords[c][0],this.listaCoords[c][1]], {
                    color: 'blue',
                    fillColor: '#f03',
                    fillOpacity: 0.2,
                    radius: 5 // metros
                }).addTo(map)
                .bindPopup(this.listaCoords[c][3]);
            }

            c++
        }

        //console.log('qnt pontos validos: ',count)

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);
    },

    created() {
        //window.scrollTo(0,0)
        //console.log('[mapa] func created')
    }
}
</script>